import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Navbar from "../components/Layout/Navbar";
import Footerpage from "../components/Layout/Footer";

const SECTIONS = [
  { id: "overview", label: "Overview", icon: "mdi:home-outline" },
  { id: "1", label: "1. About WeIntern", icon: "mdi:information-outline" },
  { id: "2", label: "2. Eligibility", icon: "mdi:account-check-outline" },
  { id: "3", label: "3. Account Registration", icon: "mdi:account-outline" },
  { id: "4", label: "4. Programs and Services", icon: "mdi:school-outline" },
  { id: "5", label: "5. Training Experience", icon: "mdi:teach" },
  { id: "6", label: "6. Internship Programs", icon: "mdi:briefcase-outline" },
  { id: "7", label: "7. Live Projects", icon: "mdi:code-braces" },
  { id: "8", label: "8. Stipend", icon: "mdi:cash" },
  { id: "9", label: "9. Placement Assistance", icon: "mdi:handshake-outline" },
  { id: "10", label: "10. Certificates", icon: "mdi:certificate-outline" },
  { id: "11", label: "11. Fees and Payments", icon: "mdi:credit-card-outline" },
  { id: "12", label: "12. Refunds & Cancellation", icon: "mdi:cash-refund" },
  { id: "13", label: "13. Promotional Offers", icon: "mdi:tag-outline" },
  { id: "14", label: "14. User Responsibilities", icon: "mdi:account-alert-outline" },
  { id: "15", label: "15. Academic Integrity", icon: "mdi:shield-check-outline" },
  { id: "16", label: "16. Intellectual Property", icon: "mdi:copyright" },
  { id: "17", label: "17. User-Submitted Content", icon: "mdi:file-document-outline" },
  { id: "18", label: "18. Confidentiality", icon: "mdi:lock-outline" },
  { id: "19", label: "19. Third-Party Services", icon: "mdi:puzzle-outline" },
  { id: "20", label: "20. Website Availability", icon: "mdi:web" },
  { id: "21", label: "21. Third-Party Links", icon: "mdi:link-variant" },
  { id: "22", label: "22. Disclaimers", icon: "mdi:alert-outline" },
  { id: "23", label: "23. Limitation of Liability", icon: "mdi:scale-balance" },
  { id: "24", label: "24. Suspension & Termination", icon: "mdi:account-cancel-outline" },
  { id: "25", label: "25. Changes to These Terms", icon: "mdi:update" },
  { id: "26", label: "26. Governing Law", icon: "mdi:gavel" },
  { id: "27", label: "27. Contact Us", icon: "mdi:phone-outline" },
];

const TermsOfService = () => {
  const [active, setActive] = useState("overview");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + 140;
      for (let i = SECTIONS.length - 1; i >= 0; i--) {
        const el = document.getElementById(SECTIONS[i].id);
        if (el && el.offsetTop <= scrollY) {
          setActive(SECTIONS[i].id);
          break;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 110, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-[#f8fafc]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />

      {/* ─── Hero ─── */}
      <section className="relative overflow-hidden bg-gradient-to-b from-[#eef4ff] via-[#f5f8ff] to-white pt-28 pb-16 sm:pt-32 sm:pb-20">
        <div className="pointer-events-none absolute right-0 top-20 h-[420px] w-[420px] rounded-full bg-blue-200/30 blur-[100px]" />
        <div className="pointer-events-none absolute left-10 top-40 h-[280px] w-[280px] rounded-full bg-indigo-100/40 blur-[80px]" />

        <div className="relative mx-auto flex max-w-6xl items-center justify-between gap-12 px-5 lg:px-8">
          <div className="max-w-xl">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-blue-200/60 bg-white/70 px-3.5 py-1.5 text-[12px] font-medium text-slate-600 backdrop-blur-sm">
              <Icon icon="mdi:file-document-outline" className="h-3.5 w-3.5 text-blue-600" />
              Legal · Terms · Your Agreement
            </div>

            <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
              Terms & Conditions
            </h1>
            <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
              Governing your access to and use of we-intern.in and related services.
            </p>

            <p className="mt-5 text-[13px] text-slate-500">
              Last Updated: 24 September 2026 &nbsp;|&nbsp; Effective Date: 24 September 2026
            </p>
          </div>

          {/* Right illustration */}
          <div className="relative hidden lg:block">
            <div className="relative h-56 w-64">
              <div className="absolute right-0 top-0 h-48 w-40 rounded-2xl bg-gradient-to-br from-blue-100 to-indigo-50 shadow-lg" />
              <div className="absolute bottom-4 left-0 flex h-36 w-36 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-xl shadow-blue-500/30">
                <Icon icon="mdi:file-document-check" className="h-16 w-16 text-white" />
              </div>
              <div className="absolute -right-4 top-8 rounded-xl border border-white/60 bg-white/90 px-3 py-2 text-[11px] font-semibold text-slate-700 shadow-md backdrop-blur">
                <div className="flex items-center gap-1.5">
                  <Icon icon="mdi:check-decagram" className="h-3.5 w-3.5 text-blue-600" />
                  Binding Terms
                </div>
                <div className="mt-0.5 text-[10px] font-normal text-slate-500">Please Read Carefully</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── Main ─── */}
      <div className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <div className="flex gap-10">
          {/* Sidebar */}
          <aside className="sticky top-28 hidden h-fit w-60 shrink-0 lg:block">
            <nav className="max-h-[calc(100vh-140px)] space-y-0.5 overflow-y-auto rounded-2xl border border-slate-200/80 bg-white p-3 shadow-sm">
              {SECTIONS.map((s) => (
                <button
                  key={s.id}
                  onClick={() => scrollTo(s.id)}
                  className={`flex w-full items-center gap-2.5 rounded-xl px-3 py-2 text-left text-[12.5px] font-medium transition-all ${
                    active === s.id
                      ? "bg-blue-50 text-blue-700"
                      : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                  }`}
                >
                  <Icon
                    icon={s.icon}
                    className={`h-4 w-4 shrink-0 ${active === s.id ? "text-blue-600" : "text-slate-400"}`}
                  />
                  <span className="truncate">{s.label}</span>
                </button>
              ))}
            </nav>
          </aside>

          {/* Content */}
          <div className="min-w-0 flex-1 space-y-7">
            {/* Overview */}
            <div id="overview" className="flex items-start gap-4 rounded-2xl border border-blue-100 bg-blue-50/60 p-5">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100">
                <Icon icon="mdi:information" className="h-5 w-5 text-blue-600" />
              </div>
              <div>
                <h3 className="text-[15px] font-semibold text-slate-900">Welcome to WeIntern</h3>
                <p className="mt-1 text-[13.5px] leading-relaxed text-slate-600">
                  These Terms & Conditions (“Terms”) govern your access to and use of the WeIntern website, platform,
                  courses, training programs, internship programs, live projects, events, career services and related
                  services operated by WeIntern Pvt Ltd. By accessing our website, creating an account, enrolling or
                  using any service, you agree to these Terms. If you do not agree, please do not use our services.
                </p>
              </div>
            </div>

            {/* 1 */}
            <section id="1">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50">
                    <Icon icon="mdi:information" className="h-4.5 w-4.5 text-blue-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">1. About WeIntern</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern is an education and career-development platform focused on helping students and learners
                  develop practical, industry-relevant skills through:
                </p>
                <div className="grid gap-x-8 gap-y-1.5 sm:grid-cols-2">
                  {[
                    "Technical training", "Skill-development programs", "Internship programs", "Live project exposure",
                    "Mentorship", "Assignments and assessments", "Portfolio development", "Resume building",
                    "Interview preparation", "Career guidance", "Placement assistance", "Industry exposure",
                    "Certificates and related documentation", "Workshops, webinars and events",
                  ].map((item) => (
                    <div key={item} className="flex items-center gap-2 text-[13.5px] text-slate-700">
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-blue-400" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="mt-3 text-[13.5px] leading-relaxed text-slate-600">
                  The specific features available to you may depend on the program, course, internship or service you select.
                </p>
              </div>
            </section>

            {/* 2 */}
            <section id="2">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-50">
                    <Icon icon="mdi:account-check" className="h-4.5 w-4.5 text-emerald-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">2. Eligibility</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">
                  You must provide accurate and complete information when registering or applying. By using our services, you represent that:
                </p>
                <ul className="space-y-1.5">
                  {[
                    "The information provided by you is accurate and complete.",
                    "You have the legal capacity to enter into these Terms.",
                    "You will comply with applicable laws and these Terms.",
                    "You will not use another person's identity or credentials.",
                    "You will not create accounts using false information.",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-[13.5px] text-slate-600">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-[11px] font-bold text-emerald-700">{i + 1}</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p className="mt-3 text-[13.5px] leading-relaxed text-slate-600">
                  If you are below the applicable age of majority, you should use our services only with the involvement and consent of your parent or legal guardian where required by law.
                </p>
              </div>
            </section>

            {/* 3 */}
            <section id="3">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-violet-50">
                    <Icon icon="mdi:account" className="h-4.5 w-4.5 text-violet-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">3. Account Registration</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">Certain WeIntern services may require you to create an account. You agree to:</p>
                <ul className="space-y-1.5">
                  {[
                    "Provide correct information and keep it updated.",
                    "Maintain the confidentiality of your login credentials.",
                    "Not share your account with another person.",
                    "Not allow another person to access paid or restricted services through your account.",
                    "Notify WeIntern promptly if you believe your account has been compromised.",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-[13.5px] text-slate-600">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-violet-400" />
                      {item}
                    </li>
                  ))}
                </ul>
                <p className="mt-3 text-[13.5px] leading-relaxed text-slate-600">
                  You are responsible for activities conducted through your account. WeIntern reserves the right to suspend or restrict accounts containing false, misleading or fraudulent information.
                </p>
              </div>
            </section>

            {/* 4 */}
            <section id="4">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-50">
                    <Icon icon="mdi:school" className="h-4.5 w-4.5 text-indigo-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">4. Programs and Services</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">WeIntern may offer different types of programs, including but not limited to:</p>
                <div className="grid gap-x-8 gap-y-1.5 sm:grid-cols-2">
                  {[
                    "Internship programs", "Training programs", "Technical courses", "Full Stack Development",
                    "Data Science", "Artificial Intelligence & Machine Learning", "Python Development", "Java Development",
                    "Data Analytics", "Cybersecurity", "UI/UX Design", "Digital Marketing",
                    "App Development", "Cloud Computing", "Workshops", "Career programs", "Live projects",
                  ].map((item) => (
                    <div key={item} className="flex items-center gap-2 text-[13.5px] text-slate-700">
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-indigo-400" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="mt-3 text-[13.5px] leading-relaxed text-slate-600">
                  Program duration, curriculum, schedule, eligibility, fees, benefits and deliverables may vary. In case of conflict between these Terms and a specific written program agreement, the specific agreement will govern.
                </p>
              </div>
            </section>

            {/* 5 */}
            <section id="5">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-cyan-50">
                    <Icon icon="mdi:teach" className="h-4.5 w-4.5 text-cyan-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">5. Training and Learning Experience</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern aims to provide practical and industry-oriented learning opportunities. However, the availability of trainers, mentors, sessions, projects, assignments, tools, technologies, instructors, schedules and learning resources may change from time to time. WeIntern reserves the right to modify the curriculum, mentor allocation, schedule, technology stack or learning methodology where reasonably necessary. Such changes will not necessarily constitute a failure to provide the service where substantially similar learning objectives continue to be provided.
                </p>
              </div>
            </section>

            {/* 6 */}
            <section id="6">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-rose-50">
                    <Icon icon="mdi:briefcase" className="h-4.5 w-4.5 text-rose-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">6. Internship Programs</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern may offer internship opportunities involving training, mentorship, assignments, practical work and/or live projects. The exact structure may vary depending on internship role, duration, project availability, participant eligibility, performance, business requirements, client requirements and project timelines.
                </p>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  An internship does not automatically constitute an offer of permanent employment. Where an internship is connected to a specific project, the participant may be assigned work based on the availability and requirements of that project.
                </p>
              </div>
            </section>

            {/* 7 */}
            <section id="7">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-50">
                    <Icon icon="mdi:code-braces" className="h-4.5 w-4.5 text-amber-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">7. Live Projects</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">
                  Where applicable, WeIntern may provide participants with exposure to live or simulated industry projects. Project allocation may depend on technical skills, availability, role requirements, project requirements, team capacity, client requirements, performance, attendance and participation.
                </p>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern does not guarantee that every participant will work on a particular client, technology, product or project unless expressly confirmed in writing. Participants must maintain confidentiality regarding confidential information, client information, credentials, source code, business information or other restricted information received during project work.
                </p>
              </div>
            </section>

            {/* 8 */}
            <section id="8">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-50">
                    <Icon icon="mdi:cash" className="h-4.5 w-4.5 text-emerald-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">8. Stipend</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">
                  Where a particular internship or live-project program expressly states that a stipend is payable, the stipend will be governed by the terms communicated for that specific program. Eligibility for payment may still be subject to the participant:
                </p>
                <ul className="space-y-1.5">
                  {[
                    "completing onboarding",
                    "actively participating in the assigned live project",
                    "completing assigned responsibilities",
                    "complying with applicable workplace/project policies",
                    "submitting required work",
                    "maintaining required attendance or participation",
                    "following reasonable instructions from mentors/project managers",
                    "remaining engaged for the applicable stipend period",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-[13.5px] text-slate-600">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />
                      {item}
                    </li>
                  ))}
                </ul>
                <p className="mt-3 text-[13.5px] leading-relaxed text-slate-600">
                  Any specific stipend amount, payment cycle and eligibility conditions communicated in the participant’s offer letter or written confirmation will take precedence over general marketing material.
                </p>
              </div>
            </section>

            {/* 9 */}
            <section id="9">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50">
                    <Icon icon="mdi:handshake" className="h-4.5 w-4.5 text-blue-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">9. Placement Assistance</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern may provide placement assistance, career guidance, interview preparation, job referrals, hiring drives or placement opportunities. Unless a separate written agreement expressly states otherwise: Placement assistance does not constitute a guarantee of employment. Employment decisions are ultimately made by the relevant employer based on its own hiring criteria. WeIntern does not guarantee a specific employer, job title, salary, number of interviews, joining date or employment within a particular period unless expressly stated in a written agreement.
                </p>
              </div>
            </section>

            {/* 10 */}
            <section id="10">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-violet-50">
                    <Icon icon="mdi:certificate" className="h-4.5 w-4.5 text-violet-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">10. Certificates</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  Where applicable, participants may receive certificates upon satisfying the requirements of the relevant program. Requirements may include completion of training, assignments, project participation, required attendance, submission of required work, completion of internship duration and compliance with program rules. A certificate does not constitute a government-recognized degree, diploma or academic qualification unless expressly stated otherwise. Participants must not alter, forge, reproduce or misuse certificates issued by WeIntern.
                </p>
              </div>
            </section>

            {/* 11 */}
            <section id="11">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-50">
                    <Icon icon="mdi:credit-card" className="h-4.5 w-4.5 text-amber-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">11. Fees and Payments</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  Certain WeIntern services may require payment of fees, including enrollment, training, internship, program, workshop or other applicable charges. Applicable fees will be displayed or communicated before payment. Payments may be processed through third-party payment service providers such as Razorpay or other payment partners. By making a payment, you authorize the applicable payment processor to process the transaction according to its own terms and privacy policies.
                </p>
              </div>
            </section>

            {/* 12 */}
            <section id="12">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-rose-50">
                    <Icon icon="mdi:cash-refund" className="h-4.5 w-4.5 text-rose-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">12. Refunds and Cancellation</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">
                  Refund eligibility will depend on the specific program and refund policy displayed at the time of enrollment. Unless a specific program states otherwise:
                </p>
                <ul className="space-y-1.5">
                  {[
                    "Fees are not automatically refundable merely because a participant changes their mind after enrollment.",
                    "Refund requests must be submitted through the official WeIntern support channel.",
                    "Third-party payment processing fees may not be refundable where legally permissible.",
                    "Any refundable amount may be subject to applicable terms and verification.",
                    "Where a specific written refund promise applies, that promise will govern.",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-[13.5px] text-slate-600">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-rose-400" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </section>

            {/* 13 */}
            <section id="13">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-50">
                    <Icon icon="mdi:tag" className="h-4.5 w-4.5 text-orange-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">13. Promotional Offers</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern may periodically offer discounts, promotional pricing, scholarships, early-bird offers, referral offers, webinar offers and limited-time enrollment offers. Unless otherwise stated, promotional offers cannot necessarily be combined, may have eligibility requirements, may have an expiration date, and may be modified or withdrawn. WeIntern reserves the right to correct pricing or promotional errors.
                </p>
              </div>
            </section>

            {/* 14 */}
            <section id="14">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100">
                    <Icon icon="mdi:account-alert" className="h-4.5 w-4.5 text-slate-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">14. User Responsibilities</h3>
                </div>
                <p className="mb-3 text-[13.5px] leading-relaxed text-slate-600">You agree to use WeIntern services responsibly. You must not:</p>
                <div className="grid gap-x-6 gap-y-1.5 sm:grid-cols-2">
                  {[
                    "Provide false information", "Impersonate another person", "Share account credentials",
                    "Copy or redistribute paid course material without permission", "Sell or commercially exploit WeIntern content",
                    "Attempt to gain unauthorized access to our systems", "Introduce malware or harmful code",
                    "Interfere with website functionality", "Scrape website data without authorization",
                    "Attempt to reverse engineer our software", "Upload unlawful or infringing content",
                    "Harass employees, mentors or other users", "Misrepresent your association with WeIntern",
                    "Misuse client or project information", "Submit plagiarized work", "Falsify project work or attendance",
                    "Use another person's work as your own", "Use WeIntern services for unlawful activities",
                  ].map((item) => (
                    <div key={item} className="flex items-start gap-2 text-[13px] text-slate-600">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-slate-400" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="mt-3 text-[13.5px] leading-relaxed text-slate-600">Violation may result in suspension or termination of access.</p>
              </div>
            </section>

            {/* 15 */}
            <section id="15">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50">
                    <Icon icon="mdi:shield-check" className="h-4.5 w-4.5 text-blue-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">15. Academic and Professional Integrity</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  Participants are expected to maintain professional and academic integrity. Plagiarism, fabrication, impersonation, cheating, falsification of documents, fake project submissions and unauthorized collaboration may result in rejection of assignments, withholding of certificates, removal from a program, cancellation of internship participation, suspension of account access or other appropriate action.
                </p>
              </div>
            </section>

            {/* 16 */}
            <section id="16">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-50">
                    <Icon icon="mdi:copyright" className="h-4.5 w-4.5 text-indigo-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">16. Intellectual Property</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  All intellectual property appearing on the WeIntern platform, including website design, branding, logos, text, graphics, videos, course materials, training materials, software, source code, UI designs, documentation, templates, presentations, images and educational resources is owned by or licensed to WeIntern or its respective licensors. Your enrollment does not transfer ownership of WeIntern’s intellectual property to you. You may use educational materials only for the permitted purpose. You may not reproduce, sell, publish, distribute, modify or commercially exploit WeIntern’s proprietary materials without prior written authorization.
                </p>
              </div>
            </section>

            {/* 17 */}
            <section id="17">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-cyan-50">
                    <Icon icon="mdi:file-document" className="h-4.5 w-4.5 text-cyan-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">17. User-Submitted Content</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  You may submit assignments, project work, feedback, testimonials, portfolio material, comments, suggestions, applications, resumes and other information. You retain ownership of your original content unless otherwise agreed. You grant WeIntern a non-exclusive right to use submitted content as reasonably necessary to provide, operate, improve and administer the applicable service. Where you voluntarily provide a testimonial or review for promotional use, WeIntern may use it for marketing purposes subject to applicable law and any permissions obtained.
                </p>
              </div>
            </section>

            {/* 18 */}
            <section id="18">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-rose-50">
                    <Icon icon="mdi:lock" className="h-4.5 w-4.5 text-rose-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">18. Confidentiality</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  During participation, you may receive access to confidential information relating to WeIntern, clients, projects, employees, other participants or business partners. You agree not to disclose, copy, distribute or misuse confidential information. Confidential information may include source code, passwords, credentials, business plans, customer information, client information, pricing, internal processes, unpublished product information and technical documentation. This obligation may continue after participation ends.
                </p>
              </div>
            </section>

            {/* 19 */}
            <section id="19">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-teal-50">
                    <Icon icon="mdi:puzzle" className="h-4.5 w-4.5 text-teal-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">19. Third-Party Services</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern may integrate or use third-party services including payment gateways, cloud hosting providers, analytics providers, communication platforms, video-conferencing platforms, email services, WhatsApp or messaging platforms, recruitment platforms, authentication services and social media platforms. Your use of those services may be subject to their respective terms and privacy policies. WeIntern is not responsible for independent actions, downtime or policies of third-party providers.
                </p>
              </div>
            </section>

            {/* 20 */}
            <section id="20">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50">
                    <Icon icon="mdi:web" className="h-4.5 w-4.5 text-blue-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">20. Website Availability</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  We aim to maintain reliable access to our website and services. However, we do not guarantee that the website or any service will always be uninterrupted, error-free, available, secure, compatible with every device or free from technical issues. Services may occasionally be unavailable due to maintenance, upgrades, infrastructure problems, security incidents or circumstances outside our reasonable control.
                </p>
              </div>
            </section>

            {/* 21 */}
            <section id="21">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100">
                    <Icon icon="mdi:link-variant" className="h-4.5 w-4.5 text-slate-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">21. Third-Party Links</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  Our website may contain links to third-party websites. These links are provided for convenience. WeIntern does not necessarily endorse or control third-party websites, products or services. Your use of third-party websites is governed by their respective terms and privacy policies.
                </p>
              </div>
            </section>

            {/* 22 */}
            <section id="22">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-50">
                    <Icon icon="mdi:alert" className="h-4.5 w-4.5 text-amber-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">22. Disclaimers</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern provides educational, training, internship and career-development services. We do not guarantee that participation in any program will result in employment, a particular salary, business success, academic success, professional certification, admission to an institution or any particular career outcome unless expressly stated in a written agreement. Learning outcomes may vary based on the participant’s effort, background, skills, participation and external circumstances.
                </p>
              </div>
            </section>

            {/* 23 */}
            <section id="23">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-rose-50">
                    <Icon icon="mdi:scale-balance" className="h-4.5 w-4.5 text-rose-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">23. Limitation of Liability</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  To the maximum extent permitted by applicable law, WeIntern shall not be liable for indirect, incidental, special, consequential or punitive damages arising from your use of our services. This may include losses relating to employment opportunities, expected income, business opportunities, data loss, third-party services, technical interruptions or reliance on information available through the platform. Nothing in these Terms excludes or limits liability that cannot legally be excluded or limited under applicable law.
                </p>
              </div>
            </section>

            {/* 24 */}
            <section id="24">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100">
                    <Icon icon="mdi:account-cancel" className="h-4.5 w-4.5 text-slate-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">24. Suspension and Termination</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern may suspend, restrict or terminate your access if you violate these Terms, engage in fraudulent activity, misuse the platform, provide false information, violate intellectual-property rights, engage in harassment or misconduct, compromise platform security or where such action is otherwise reasonably necessary to protect users, WeIntern or third parties. Termination does not automatically eliminate obligations that by their nature should survive termination.
                </p>
              </div>
            </section>

            {/* 25 */}
            <section id="25">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-50">
                    <Icon icon="mdi:update" className="h-4.5 w-4.5 text-amber-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">25. Changes to These Terms</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  WeIntern may update these Terms from time to time. Updated Terms will be published on this page with an updated “Last Updated” date. Your continued use of the website or services after an update constitutes acceptance of the updated Terms to the extent permitted by applicable law. For material changes, WeIntern may provide additional notice where required.
                </p>
              </div>
            </section>

            {/* 26 */}
            <section id="26">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-50">
                    <Icon icon="mdi:gavel" className="h-4.5 w-4.5 text-indigo-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">26. Governing Law and Jurisdiction</h3>
                </div>
                <p className="text-[13.5px] leading-relaxed text-slate-600">
                  These Terms shall be governed by the laws of India. Subject to applicable law, disputes arising from these Terms or your use of WeIntern services shall be subject to the jurisdiction of the competent courts at Pune, Maharashtra, India. Before initiating formal proceedings, the parties should attempt to resolve the dispute through good-faith communication.
                </p>
              </div>
            </section>

            {/* 27 */}
            <section id="27">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="mb-4 flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50">
                    <Icon icon="mdi:phone" className="h-4.5 w-4.5 text-blue-600" />
                  </div>
                  <h3 className="text-[15px] font-semibold text-slate-900">27. Contact Us</h3>
                </div>
                <p className="mb-4 text-[13.5px] font-medium text-slate-800">WeIntern Pvt Ltd</p>
                <div className="space-y-2 text-[13.5px] text-slate-600">
                  <div className="flex gap-3"><span className="w-28 shrink-0 font-medium text-slate-800">Website</span> https://we-intern.in</div>
                  <div className="flex gap-3"><span className="w-28 shrink-0 font-medium text-slate-800">Email</span> support@we-intern.in</div>
                  <div className="flex gap-3"><span className="w-28 shrink-0 font-medium text-slate-800">Phone</span> +91 7414974582</div>
                </div>
              </div>
            </section>

            {/* Bottom CTA */}
            <div className="flex flex-col items-start justify-between gap-5 rounded-2xl border border-blue-100 bg-blue-50/70 p-6 sm:flex-row sm:items-center">
              <div className="flex items-start gap-4">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
                  <Icon icon="mdi:file-document-check" className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-[15px] font-semibold text-slate-900">
                    Questions about these Terms?
                  </h3>
                  <p className="mt-1 text-[13px] text-slate-600">
                    We’re here to help. Feel free to contact our support team.
                  </p>
                </div>
              </div>
              <Link
                to="/#contact"
                className="inline-flex shrink-0 items-center gap-2 rounded-full border border-blue-600 bg-white px-5 py-2.5 text-sm font-semibold text-blue-600 transition hover:bg-blue-600 hover:text-white"
              >
                Contact Us
                <Icon icon="mdi:arrow-right" className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footerpage />
    </div>
  );
};

export default TermsOfService;